import { ShortlistWithScores } from "PFApp/activities/manage_roles/parts/suggested_wm_side_panel/suggested_shortlists_table/types";
import { ActionIcon } from "PFComponents/action_icon";
import { useErrorsGrowl } from "PFCore/hooks";
import { useInvalidateManageViewRoles } from "PFCore/hooks/queries/roles/use_invalidate_manage_view_roles";
import { useShortlistUpdate } from "PFCore/hooks/queries/shortlists/use_shortlist_update";

type ActionCellContentProps = {
  item: ShortlistWithScores;
};

export const ActionCellContent = ({ item }: ActionCellContentProps) => {
  const growlErrors = useErrorsGrowl();
  const { invalidateAll: invalidateManageViewRoles } = useInvalidateManageViewRoles();
  const { mutateAsync: updateShortlist, isPending } = useShortlistUpdate({
    activityId: item.activityId,
    options: { onSuccess: () => invalidateManageViewRoles(), onError: (error) => growlErrors(error) }
  });

  if (["booked", "confirmed"].includes(item.state)) {
    return null;
  }

  return (
    <ActionIcon
      name="cross"
      onClick={() => updateShortlist({ id: item.id, data: { suggested: null } })}
      disabled={isPending}
    />
  );
};
